import { Component, Input } from '@angular/core';
import { Theme } from 'studio-components';
@Component({
  selector: 'studio-spinner-label',
  templateUrl: './spinner-label.component.html',
  styleUrls: ['./spinner-label.component.scss'],
})
export class SpinnerLabelComponent {
  @Input() spinning = false;
  @Input() spinningLabel: string;
  @Input() staticLabel: string;
  @Input() spinnerTheme: Theme = 'light';
  @Input() spinnerSize: number = 20;

  get label() {
    return this.spinning ? this.spinningLabel : this.staticLabel;
  }
}
